function ActivityIcon({ color }) {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 10.5L5.5 7L8.5 10L12 6.5L16 10.5"
                stroke={color || "#505050"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 15H16"
                stroke={color || "#505050"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="9" cy="3" r="1.5"
                stroke={color || "#505050"} strokeWidth="1.5" />
        </svg>
    );
}

export default ActivityIcon;
